import round from 'lodash/round';
import { ComputeResourceType } from '@cast/shared-types';

import { computeResourceUnitsMap } from 'constants/maps';

import { PreparedWorkload } from 'features/workload-optimization';
import { DiffIcon } from '../../_components/DiffIcon';

import { OptimizationNotEnabledTooltip } from '../../_components/OptimizationNotEnabledTooltip';
import { Typography, Box, Stack } from '@cast/design-system';

type DiffRowProps = {
  diff: number | undefined;
  isReadOnly: boolean | undefined;
  unit: ComputeResourceType;
};
const DiffRow = ({ diff, isReadOnly, unit }: DiffRowProps) => {
  if (diff === undefined) {
    return (
      <Box className="woop-premium-value" ml={24} data-testid={`${unit}-row`}>
        -
      </Box>
    );
  }
  return (
    <OptimizationNotEnabledTooltip unit={unit} wrapIf={isReadOnly}>
      <Stack direction="row" alignItems="center" data-testid={`${unit}-row`}>
        <DiffIcon
          diff={diff}
          isReadOnly={isReadOnly}
          size={16}
          sx={diff > 0 ? { color: 'grey.900' } : undefined}
        />
        {!!diff && (
          <>
            <Typography
              className="woop-premium-value"
              variant="P12R"
              ml={8}
              noWrap
              color={isReadOnly ? 'grey.300' : 'inherit'}
              data-testid="value"
            >
              {round(Math.abs(diff), 3)}
            </Typography>
            <Typography
              variant="P12R"
              pl={3}
              textAlign="left"
              color={isReadOnly ? 'grey.300' : 'grey.400'}
            >
              {computeResourceUnitsMap[unit]}
            </Typography>
          </>
        )}
      </Stack>
    </OptimizationNotEnabledTooltip>
  );
};

type DiffCellProps = {
  workload: PreparedWorkload;
  diffKey: 'diff' | 'currentDiff';
};

export const DiffCell = ({
  workload: { cpu, memory },
  diffKey,
}: DiffCellProps) => {
  return (
    <Stack
      data-testid="diff-root"
      data-cpu-diff={Math.abs(cpu[diffKey] ?? 0)}
      data-memory-diff={Math.abs(memory[diffKey] ?? 0)}
    >
      <DiffRow
        diff={cpu[diffKey]}
        isReadOnly={cpu.isReadOnly}
        unit={ComputeResourceType.CPU}
      />
      <DiffRow
        diff={memory[diffKey]}
        isReadOnly={memory.isReadOnly}
        unit={ComputeResourceType.MEMORY}
      />
    </Stack>
  );
};
